import React from "react";
import { Link } from "react-router-dom";

const ServicesHeader = ({
  badge = "OTHER LANGUAGE SERVICES",
  title = "NKENNEAi’s Professional Language Services",
  description = "Beyond our core language solutions, our in-office team provides a comprehensive range of professional language services designed to ensure accuracy, clarity, consistency, and quality across every project. Our experienced linguists and language professionals work closely with project requirements, following defined processes and quality checks to deliver reliable, client-ready content.",
  ctaText = "Contact Us",
  ctaLink = "/contact-us",
}) => {
  return (
    <div className="flex flex-col items-center text-center mx-auto" data-aos="fade-up">
      {/* Category Eyebrow Badge */}
      <span className="text-[#EF8702] text-base font-black tracking-[0.18em] uppercase mb-3 font-['Axiforma',sans-serif]">
        {badge}
      </span>

      {/* Main Heading */}
      <h1 className="text-3xl sm:text-4xl lg:text-[44px] font-extrabold text-[#111827] tracking-tight leading-[1.2] font-['Axiforma',sans-serif]">
        {title}
      </h1>

      {/* Description Paragraph */}
      <p className="mt-5 text-[#374151] text-sm sm:text-base leading-relaxed max-w-3xl sm:max-w-4xl font-normal">
        {description}
      </p>

      {/* Contact Us CTA Button */}
      <div className="mt-7 sm:mt-8">
        <Link
          to={ctaLink}
          className="inline-flex items-center justify-center px-8 py-3 rounded-xl bg-[#1E6C56] hover:bg-[#165644] text-white text-sm sm:text-base font-semibold shadow-sm hover:shadow-md transition-all duration-200 active:scale-95"
        >
          {ctaText}
        </Link>
      </div>
    </div>
  );
};

export default ServicesHeader;
